import React from "react";
import { Button, InputNumber } from "antd";
import WeaTools from "../../wea-tools";
import WeaDialog from "../../wea-dialog";
import WeaRightMenu from "../../wea-right-menu";
import WeaFormItem from "../../wea-form-item";
import WeaInput from "../../wea-input";
import WeaSelect from "../../wea-select";
import WeaBrowser from "../../wea-browser";
import WeaError from "../../wea-error";
import WeaLocaleProvider from "../../wea-locale-provider";
const getLabel = WeaLocaleProvider.getLabel;

export default class Main extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      type: "0",
      sn: null,
      hrmids: "",
      hrmidsDatas: [],
      savable: true
    };
  }
  init() {
    this.setState({
      name: "",
      type: "0",
      sn: null,
      hrmids: "",
      hrmidsDatas: []
    });
  }
  render() {
    const { visible, onVisableChange } = this.props;
    return (
      <div>
        <WeaDialog
          title={getLabel(81554, "常用组")}
          hasScroll={true}
          visible={visible}
          icon={"icon-coms-workflow"}
          iconBgcolor="#0079DE"
          closable={true}
          onCancel={() => {
            onVisableChange(false);
            this.init();
          }}
          buttons={this.getAddModalButtons()}
          style={{ height: "300px", width: "500px" }}
          className={"wea-dialog-add-group-modal"}
        >
          <WeaRightMenu datas={this.getRightMenu()}>
            {this.initGroup()}
          </WeaRightMenu>
        </WeaDialog>
      </div>
    );
  }

  initGroup() {
    const { name, sn, type, hrmidsDatas } = this.state;
    return (
      <div className="wea-form-item-group wea-addgroup-form">
        <WeaFormItem
          label={getLabel(33439, "名称")}
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 18 }}
          domkey={"name"}
        >
          <WeaError
            tipPosition="bottom"
            ref="weaErrorName"
            error={getLabel(385562, '"名称"未填写').replace(/&quot;/g, '"')}
          >
            <WeaInput
              viewAttr={3}
              value={name}
              onChange={v => {
                this.setState({ name: v });
                if (!v) this.refs.weaErrorName.showError();
              }}
            />
          </WeaError>
        </WeaFormItem>
        <WeaFormItem
          label={getLabel("132033", "类型")}
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 18 }}
          domkey={"type"}
        >
          <WeaSelect
            value={type}
            onChange={v => {
              this.setState({ type: v });
            }}
            options={[
              {
                key: "0",
                selected: true,
                showname: getLabel(17618, "私人组")
              },
              {
                key: "1",
                selected: false,
                showname: getLabel(17619, "公共组")
              }
            ]}
          />
        </WeaFormItem>
        <WeaFormItem
          label={getLabel(338, "排序")}
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 18 }}
          domkey={"sn"}
        >
          <InputNumber
            value={sn}
            min={1}
            onChange={v => {
              this.setState({ sn: v });
            }}
          />
        </WeaFormItem>
        <WeaFormItem
          label={getLabel(431, "成员")}
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 18 }}
          domkey={"hrmids"}
        >
          <WeaError
            tipPosition="bottom"
            ref="weaErrorHrmids"
            error={getLabel(385563, '"成员"未填写').replace(/&quot;/g, '"')}
          >
            <WeaBrowser
              mr0
              type={17}
              isSingle={false}
              title={getLabel(83496, "多人力资源")}
              viewAttr={3}
              valueObj={hrmidsDatas}
              onChange={(v, n, datas) => {
                this.setState({ hrmids: v, hrmidsDatas: datas });
                if (!v) this.refs.weaErrorHrmids.showError();
              }}
            />
          </WeaError>
        </WeaFormItem>
      </div>
    );
  }

  getRightMenu() {
    let btns = [];
    btns.push({
      key: "add",
      icon: <i className="icon-coms-Preservation" />,
      content: getLabel(30986, "保存"),
      onClick: () => {
        this.doSave();
      }
    });
    return btns;
  }
  validate() {
    let bool = true;
    const { name, hrmids } = this.state;
    if (!name) {
      bool = false;
      this.refs.weaErrorName.showError();
    }
    if (!hrmids) {
      bool = false;
      this.refs.weaErrorHrmids.showError();
    }
    return bool;
  }
  doSave() {
    const { savable } = this.state;
    if (savable && this.validate()) {
      const resetSavable = () => this.setState({ savable: true });
      this.setState({ savable: false });
      const params = { ...this.state };
      params.cmd = "base";
      delete params.hrmidsDatas;
      WeaTools.callApi(
        "/api/workflow/forward/saveUserGroupCmd",
        "POST",
        params
      ).then(
        () => {
          resetSavable();
          this.init();
          this.props.onVisableChange();
        },
        () => {
          resetSavable();
          window.alert(getLabel(385564, "添加常用组失败！"));
        }
      );
    }
  }

  getAddModalButtons() {
    return [
      <Button
        type="primary"
        onClick={() => {
          this.doSave();
        }}
      >
        {getLabel(30986, "保存")}
      </Button>
    ];
  }
}



// WEBPACK FOOTER //
// ./ecology9/wea-browser-test/components/addGroup.js